import { useQuery } from '@tanstack/react-query'
import { featureFlagsService } from '@/services/featureFlags'
import { useAuthStore } from '@/stores/auth'

const orgFeatureFlagKeys = {
  all: () => ['organizationFeatureFlags'] as const,
  byOrg: (orgId: string) => [...orgFeatureFlagKeys.all(), orgId] as const,
}

export function useOrganizationFeatureFlags() {
  const { organization } = useAuthStore()
  const orgId = organization?.id ?? ''

  const { data: flags = {}, isLoading } = useQuery({
    queryKey: orgFeatureFlagKeys.byOrg(orgId),
    queryFn: () => featureFlagsService.getOrganizationFlags(),
    enabled: !!orgId,
    staleTime: 2 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  })

  return { flags, isLoading }
}

export function useOrganizationFeatureFlag(flagName: string) {
  const { flags, isLoading } = useOrganizationFeatureFlags()

  return {
    enabled: flags[flagName] ?? false,
    isLoading,
  }
}
